import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TGpsrStore,
	TGetProductTypeRequest,
	TGetProductTypeResponsePayload,
	TSkuRequest,
	TSkuResponsePayload,
	TDownloadFileRequest,
} from './types';
// ==========================================:
export const initialState: TGpsrStore = {
	productType: null,
	productTypeLoading: false,
	productTypeError: '',
	sku: null,
	skuLoading: false,
	skuError: '',
	downloadFileLoading: false,
};

// ==========================================:
const gpsr = createSlice({
	name: '@@gpsr',
	initialState,
	reducers: {
		getProductTypeRequest: (state: TGpsrStore, action: PayloadAction<TGetProductTypeRequest>) => {
			const gpsrState = state;
			gpsrState.productTypeLoading = true;
			gpsrState.productTypeError = '';
		},
		getProductTypeSuccess: (
			state: TGpsrStore,
			action: PayloadAction<TGetProductTypeResponsePayload>,
		) => {
			const gpsrState = state;
			gpsrState.productType = action.payload;
			gpsrState.productTypeLoading = false;
			gpsrState.productTypeError = '';
		},
		getProductTypeError: (state: TGpsrStore, action: PayloadAction<string>) => {
			const gpsrState = state;
			gpsrState.productTypeLoading = false;
			gpsrState.productTypeError = action.payload;
		},
		getSkuRequest: (state: TGpsrStore, action: PayloadAction<TSkuRequest>) => {
			const gpsrState = state;
			gpsrState.skuLoading = true;
			gpsrState.skuError = '';
		},
		getSkuSuccess: (state: TGpsrStore, action: PayloadAction<TSkuResponsePayload>) => {
			const gpsrState = state;
			gpsrState.sku = action.payload;
			gpsrState.skuLoading = false;
			gpsrState.skuError = '';
		},
		getSkuError: (state: TGpsrStore, action: PayloadAction<string>) => {
			const gpsrState = state;
			gpsrState.skuLoading = false;
			gpsrState.skuError = action.payload;
		},
		downloadFileRequest: (state: TGpsrStore, action: PayloadAction<TDownloadFileRequest>) => {
			const gpsrState = state;
			gpsrState.downloadFileLoading = true;
		},
		downloadFileSuccess: (state: TGpsrStore) => {
			const gpsrState = state;
			gpsrState.downloadFileLoading = false;
		},

		gpsrInitState: () => initialState,
	},
});

export default gpsr.reducer;
export const {
	getProductTypeRequest,
	getProductTypeSuccess,
	getProductTypeError,
	getSkuRequest,
	getSkuSuccess,
	getSkuError,
	downloadFileRequest,
	downloadFileSuccess,
	gpsrInitState,
} = gpsr.actions;
